const customerSearch = {
  'customerSearch.placeholder':
    'Buscar por email, número de documento ou número da conta bancária.',
  'customerSearch.placeholderCardNumber': 'Buscar por número do cartão',
  'customerSearch.tip':
    'Buscar por nome, número de documento, email ou telefone.',
  'customerSearch.tipV2':
    'Buscar por email, número de documento ou número da conta bancária.',
  'customerSearch.searchByCardNumber': 'Buscar por número do cartão',
  'customerSearch.searchUser': 'Buscar usuário',
  'customerSearch.search': 'buscar',
};

export default customerSearch;
